// extracted by mini-css-extract-plugin
export default {"container":"container_bvfF0","controlsContainer":"controlsContainer_x8iKh","isWebView":"isWebView_d8DI6"};